import { render, staticRenderFns } from "./DocumentRowDetail.vue?vue&type=template&id=3daa8e90"
import script from "./DocumentRowDetail.vue?vue&type=script&lang=js"
export * from "./DocumentRowDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports